/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { CourierUser, CourierUserFromJSON, CourierUserToJSON } from './CourierUser';
import { RewardPrize, RewardPrizeFromJSON, RewardPrizeToJSON } from './RewardPrize';
/**
 * 
 * @export
 * @interface RewardsClaim
 */
export interface RewardsClaim {
    /**
     * 
     * @type {string}
     * @memberof RewardsClaim
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof RewardsClaim
     */
    lastUpdated?: Date;
    /**
     * 
     * @type {number}
     * @memberof RewardsClaim
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsClaim
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsClaim
     */
    rewardPrizeId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsClaim
     */
    courierId?: number;
    /**
     * True once the prize cost has been returned because the claim was rejected.
     * @type {boolean}
     * @memberof RewardsClaim
     */
    pointsRefunded?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RewardsClaim
     */
    refundedOn?: Date;

    rewardPrize?: RewardPrize;
    courierUser?: CourierUser;
}

/**
 * Check if a given object implements the RewardsClaim interface.
 */
export function instanceOfRewardsClaim(value: object): value is RewardsClaim {
    return true;
}

export function RewardsClaimFromJSON(json: any): RewardsClaim {
    return RewardsClaimFromJSONTyped(json, false);
}

export function RewardsClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardsClaim {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'lastUpdated': json['lastUpdated'] == null ? undefined : (new Date(json['lastUpdated'])),
        'id': json['id'] == null ? undefined : json['id'],
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'rewardPrizeId': json['rewardPrizeId'] == null ? undefined : json['rewardPrizeId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'pointsRefunded': json['pointsRefunded'] == null ? undefined : json['pointsRefunded'],
        'refundedOn': json['refundedOn'] == null ? undefined : (new Date(json['refundedOn'])),
        'rewardPrize': json['rewardPrize'] == null ? undefined : RewardPrizeFromJSON(json['rewardPrize']),
        'courierUser': json['courierUser'] == null ? undefined : CourierUserFromJSON(json['courierUser']),
    };
}

export function RewardsClaimToJSON(json: any): RewardsClaim {
    return RewardsClaimToJSONTyped(json, false);
}

export function RewardsClaimToJSONTyped(value?: RewardsClaim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'lastUpdated': value['lastUpdated'] == null ? undefined : ((value['lastUpdated']).toISOString()),
        'id': value['id'],
        'courierUserId': value['courierUserId'],
        'rewardPrizeId': value['rewardPrizeId'],
        'courierId': value['courierId'],
        'pointsRefunded': value['pointsRefunded'],
        'refundedOn': value['refundedOn'] == null ? undefined : ((value['refundedOn']).toISOString()),
        'rewardPrize': value['rewardPrize'] == null ? undefined : RewardPrizeToJSON(value['rewardPrize']),
        'courierUser': value['courierUser'] == null ? undefined : CourierUserToJSON(value['courierUser']),
    };
}

